import React, {useState} from 'react';
import { Container, Row, Col, Image, Form, Button, Modal } from 'react-bootstrap';
import CharacterCarousel from './CharacterCarousel';
import { Spinner } from 'react-bootstrap';
import firebaseApp from '../../firebase'
import TermsOfServiceModal from '../TOS/TermsOfServiceModal';
import firebase, {auth} from '../../firebase'

const { v4: uuidv4 } = require('uuid');
const uuid = uuidv4();

console.log(uuid);

const SignUp = () => {
    const [isLoading, setLoading ] = useState(false)
    const [message, setMessage] = useState("")
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [email, setEmail] = useState("")

    const [isTermsModalOpen, setTermsModalOpen] = useState(false);
    const openTermsModal = () => {
      setTermsModalOpen(true);
    };
    const closeTermsModal = () => {
      setTermsModalOpen(false);
    };

    const backgroundImageStyle = {
    backgroundImage: `url('/images/base.png')`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    opacity: 1.0,
    fontFamily:"Poppins"
  };


  const titleStyle = {
    fontSize: '1.5rem',
    marginBottom: '1rem',
  };

  const subheadingStyle = {
    fontSize: '0.9rem',
    marginBottom: '2rem',
  };

  const formContainerStyle = {
    backgroundColor: 'white',
    padding: '1rem',
    borderRadius: '8px',
  };

  const formStyle = {
    fontSize: '1rem',
  };
  const handleChange = (e)=>{
    setUsername(e.target.value)
    
  }
  const handleEmailChange = (e)=>{
    setEmail(e.target.value)
    
  }
  const handlePasswordChange = (e)=>{
    setPassword(e.target.value)
  }
  function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  
    return emailRegex.test(email);
  }
  const signUp = (email, password) => {
    
    auth.createUserWithEmailAndPassword(email, password).then((userCredential)=>{
        // add entry for username
        const user = userCredential.user;
        user.updateProfile({
            displayName: username,
            })
            .then(() => {
            console.log('Username added to the user profile successfully.');
            })
            .catch((error) => {
            setMessage('Error adding username to the user profile:'+ error.code);
            });
        setLoading(false)
        
    }).catch((error)=>{
        setMessage(error.code)
        setLoading(false)
        
    })

  };
  const handleSignUp = (e) => {
    e.preventDefault();
    
    // if already loading dont send request again
    if (!isLoading){
        if (username.length<5){
            setMessage("username must have more than 5 characters")
            return
        }
        if (!isValidEmail(email)){
            setMessage("email invalid")
            return
        }
        if (password.length < 8){
            setMessage("password must have 8 or more characters")
            return
        }
        setMessage("")
        setLoading(true)
        signUp(email, password)
    }else{

    }


    // Open a modal or a new window to display your Terms of Service (TOS).
  
  }
  return (
    <div style={backgroundImageStyle}>
      <TermsOfServiceModal isOpen={isTermsModalOpen} onRequestClose={closeTermsModal} />
      <Container>
        <Row className="justify-content-center vh-100 align-items-center">
          <Col lg={6} style={formContainerStyle}>
     
            <h1 style={{textAlign:'center'}}>
              NNN Christian Bale🦇
            </h1>
            <Form style={formStyle}  onSubmit={handleSignUp}>
              <h3 className="text-center mb-3">Sign Up</h3>

              <Form.Group className="mb-3">
                <Form.Label>Display Username</Form.Label>
                <Form.Control type="text" placeholder="Enter your username" onChange={handleChange} value={username} required/>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" placeholder="Enter your email" onChange={handleEmailChange} value={email} required/>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="Enter your password" onChange={handlePasswordChange} value={password} required/>
              </Form.Group>
              By Clicking Proceed you're agreeing to the <a
                href="#"
                onClick={(e)=>{e.preventDefault();openTermsModal()}}
              >
                Terms of Service
              </a>
              
              <br/>
              <Button variant="primary" type="submit" disabled={isLoading}>
                Proceed
              </Button>
              {isLoading?<Spinner/>:""}

              
            </Form>
            <p style={{color:"red"}}>{message}</p>
          </Col>
          <CharacterCarousel />
        </Row>
        
      </Container>

      <footer>
        
      </footer>
    </div>
  );
};

export default SignUp;
